export default {
  UPDATE_TOTAL_PROCESSES(state, payload) {
    state.totalProcesses = payload;
  },
  UPDATE_PROCESSOS_ARQUIVOS(state, payload) {
    state.processosArquivos = payload;
  },
  UPDATE_TOTAL_PROCESSES_SERIES(state, payload) {
    state.totalProcessesSeries = payload;
  },
  UPDATE_TOTAL_PROCESSES_BY_STATUS(state, payload) {
    state.totalProcessesByStatus = payload;
  },
  UPDATE_PROCESSES(state, payload) {
    state.processes = payload;
  },
  SELECT_PROCESS(state, payload) {
    state.selectedProcess = payload;
  },
  SET_OBJECT(state, payload) {
    state.objectSelected = payload;
  },
  LIS_PROCESS(state, payload) {
    state.lisProcess.lis = payload.lis;
  },
  UPDATE_COLUNAS_DISPONIVEIS(state, payload) {
    state.colunasDisponiveis = payload;
  },
  SET_FILTRO_MAPA_STATUS(state, payload) {
    state.filtroMapaStatus = payload;
  },
  SET_PROCESSOS_FILTRAR(state, payload) {
    state.processosFiltrar = payload;
  },
  SET_EM_TEMPO_ATRASADOS(state, payload) {
    const { atrasados, adiantados, emTempo, ...rest } = payload;
    state.emTempoAtrasados.data = [atrasados, adiantados, emTempo];
    state.emTempoAtrasados.atrasados = atrasados;
    state.emTempoAtrasados.adiantados = adiantados;
    state.emTempoAtrasados.emTempo = emTempo;
    Object.assign(state.emTempoAtrasados, rest);
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_DOCUMENTOS_PROCESSO_SELECIONADO(state, payload) {
    state.documentosProcessoSelecionado = payload;
  },
};
